import Joi from 'joi';
import { planControllers } from '../../constants';

const PlanItemSchema = Joi.object({
  controller: Joi.string().valid(
    planControllers.RADIO,
    planControllers.COUNTER,
    planControllers.DROPDOWN,
    planControllers.NONE
  ),
  groupControllerType: Joi.string(),
  headline: Joi.string(),
  icon: Joi.string(),
  name: Joi.string(),
  position: Joi.string(),
  visible: Joi.boolean(),
});

const PlanInfoSchema = PlanItemSchema.concat(
  Joi.object({
    controllerValues: Joi.array().items(
      Joi.object({
        key: Joi.string(),
        value: Joi.number(),
      })
    ),
  })
);

const AddOnsSchema = Joi.object({
  addon_group: Joi.array().items(
    Joi.object({
      group_info: PlanInfoSchema,
      group_items: Joi.array().items(PlanItemSchema),
    })
  ),
});

export const PlansSchema = Joi.array().items(
  Joi.object({
    created_at: Joi.string(),
    description: Joi.string(),
    descriptionPlanItem: Joi.string(),
    kaltura_analytic_ref: Joi.string(),
    license_items: Joi.array().items(
      Joi.object({
        name: Joi.string(),
        value: Joi.string(),
      })
    ),
    name: Joi.string(),
    plan_type: Joi.string(),
    pricing_info: Joi.array().items(
      Joi.object({
        billing_cycle: Joi.string(),
        currency: Joi.string(),
        description: Joi.string(),
        id: Joi.string(),
        price: Joi.number(),
      })
    ),
    product: Joi.string(),
    remote_ref_id: Joi.string(),
    remote_ref_system_id: Joi.string(),
    status: Joi.number(),
    __v: Joi.number(),
    _id: Joi.string(),
  })
);

const MarketingInfoDto = Joi.array().items(Joi.object({
  name: Joi.string(),
  question: Joi.string(),
  possibleAnswers: Joi.array().items(Joi.string()),
  type: Joi.number(),
  isMandatory: Joi.boolean(),
  imageUrl: Joi.string(),
}));

export const PackageDetailSchema = Joi.object({
  annually_headline: Joi.string(),
  created_at: Joi.string(),
  currency_code: Joi.string(),
  description: Joi.string(),
  get_started_text: Joi.string(),
  leading_plan: PlanItemSchema,
  monthly_addons: AddOnsSchema,
  monthly_headline: Joi.string(),
  name: Joi.string(),
  plans: PlansSchema,
  promotional_credit: Joi.number(),
  status: Joi.number(),
  type: Joi.string(),
  what_does_it_include: Joi.string(),
  summary_text: Joi.string(),
  checkout_cta_text: Joi.string(),
  yearly_addons: AddOnsSchema,
  __v: Joi.number(),
  _id: Joi.string(),
  marketing_info: MarketingInfoDto
});

export const PlanTypeSchema = Joi.object({
  name: Joi.string(),
  quantity: Joi.number(),
});

export const PlanPayloadSchema = Joi.object({
  billing_cycle: Joi.string(),
  partner_id: Joi.number(),
  addons: Joi.array().items(PlanTypeSchema),
  plan: PlanTypeSchema,
  product: Joi.string(),
  currency: Joi.string(),
  coupon_ids: Joi.array().items(Joi.string()),
});

export const LoginUrlResponseSchema = Joi.object({
  url: Joi.string(),
  type: Joi.string(),
  body: Joi.object({
    userId: Joi.string(),
    userKs: Joi.string(),
    ref: Joi.string(),
  }),
});

export const PlanBuildResponseSchema = Joi.object({
  id: Joi.number(),
  _id: Joi.string(),
  status: Joi.string(),
  coupon_ids: Joi.array().items(Joi.string()),
});

export const CalculateResponseSchema = Joi.object({
  amountDue: Joi.number(),
  secureAmount: Joi.number(),
  couponDiscount: Joi.array().items(
    Joi.object({
      amount: Joi.number(),
      coupon_id: Joi.string(),
    })
  ),
  taxes: Joi.object({
    taxAmount: Joi.number(),
    taxRate: Joi.number(),
    taxableAmount: Joi.number(),
  }),
});

export const ApplyCouponResponseSchema = Joi.object({
  applyCouponId: Joi.string(),
});

export const CouponInfoResponseSchema = Joi.object({
  discount: Joi.object({
    discountType: Joi.string(),
    discountAmount: Joi.number(),
    discountApplyOnType: Joi.string(),
    discountCurrency: Joi.string(),
  }),
  duration: Joi.object({
    durationType: Joi.string(),
    limitedPeriodAmount: Joi.number(),
    limitedPeriodTime: Joi.string(),
  }),
  invoice_name: Joi.string(),
  name: Joi.string(),
  redemptions: Joi.number(),
  remote_ref_id: Joi.string(),
  status: Joi.string(),
  validity: Joi.object({ maximumRedemptions: Joi.number() }),
  __v: Joi.number(),
  _id: Joi.string(),
});

export const UseCasesSchema = Joi.array().items(Joi.string());
